/**
 * McpUserEvents
 * Registry of events for the MCP setup page and connect wizard.
 */
export enum McpUserEvents {
    SelectClient = "MCP - Select Client",
    OpenConnectWizard = "MCP - Open Connect Wizard",
    CreateConnectionAttempted = "MCP - Create Connection Attempted",
    CreateConnectionSuccess = "MCP - Create Connection Success",
    CreateConnectionError = "MCP - Create Connection Error",
    ViewApiKeys = "MCP - View API Keys",
}
